import { ReactNode } from "react";
import {
  Badge as AntdMobileBadge,
  BadgeProps as AntdMobileBadgeProps,
} from "antd-mobile";
import { BaseComponentProps, Variant, Size } from "../types";
import "./Badge.scss";
import ExclamationPointImg from "@/assets/common/exclamation_point.webp";

export interface BaseBadgeProps
  extends Omit<AntdMobileBadgeProps, "children">,
    BaseComponentProps {
  children?: ReactNode;
  content?: ReactNode;
  variant?: Variant | "exclamation";
  size?: Size;
  dot?: boolean;
  offset?: [number, number];
  className?: string;
}

export const Badge: React.FC<BaseBadgeProps> = ({
  children,
  content,
  variant = "error",
  size = "md",
  dot = false,
  className = "",
  testId,
  ...props
}) => {
  const badgeClass = [
    "badge",
    `badge--${variant}`,
    `badge--${size}`,
    dot && "badge--dot",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // 如果是感叹号变体，显示感叹号图片或数字
  const badgeContent =
    variant === "exclamation" ? (
      dot ? (
        <img src={ExclamationPointImg} alt="exclamation" />
      ) : (
        content
      )
    ) : dot ? (
      AntdMobileBadge.dot
    ) : (
      content
    );

  return (
    <AntdMobileBadge
      className={badgeClass}
      content={badgeContent}
      data-testid={testId}
      {...props}
    >
      {children}
    </AntdMobileBadge>
  );
};

export default Badge;
